<pr-patient-documents
  displayMode="menuItem"
  [patient]="patient"
  [resetOnSelection]="true"
  (menuOpened)="onMenuOpened()"
  (documentSelected)="onDocumentSelected($event)"
/>
